const colorsObject = {
  yellow: 'amarela',
  blue: 'azul',
  white: 'branca',
  orange: 'laranja',
  purple: 'lilás',
  brown: 'marrom',
  beige: 'nude',
  black: 'preta',
  pink: 'rosa',
  red: 'vermelha',
  green: 'verde',
  other: 'outra'
};

export default colorsObject;
